const state = {
  screen: 0,
  screen_text: "",
  domain: null
};
export default state;
